var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBin = function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M1 3.5h12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.366 3.5a.7.7 0 1 0-1.4 0zm-9.333 0a.7.7 0 1 0-1.4 0zm.6 0a.7.7 0 1 0 1.4 0zm5.333 0a.7.7 0 1 0 1.4 0zm2 0v9.8h1.4V3.5zm0 9.8c0 .42-.315.7-.633.7v1.4c1.155 0 2.033-.973 2.033-2.1zm-.633.7H3.666v1.4h6.667zm-6.667 0c-.318 0-.633-.28-.633-.7h-1.4c0 1.127.878 2.1 2.033 2.1zm-.633-.7V3.5h-1.4v9.8zm2-9.8V2.1h-1.4v1.4zm0-1.4c0-.42.315-.7.633-.7V0C4.511 0 3.633.973 3.633 2.1zm.633-.7h2.667V0H5.666zm2.667 0c.318 0 .633.28.633.7h1.4c0-1.127-.878-2.1-2.033-2.1zm.633.7v1.4h1.4V2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.666 7v4.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.334 7v4.2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v15.4H0z"
  })))));
};
export default SvgBin;